<div class="recover-password-container" fxLayout="row" fxLayoutAlign="center">
    <div fxFlex="40" fxFlex.lt-md="100">
        <lib-recover-pwd [mailSendText]="'A password recovery code will be sent to user\'s e-mail.'|i18n"
                         (pwdRecovered)="onPasswordRecovered()"
                         (infoMsg)="onInfoOccurred($event)"
                         (errorMsg)="onErrorOccurred($event)">
        </lib-recover-pwd>
    </div>
</div>
